<template>
  <BaseModal
    class="scoped"
    :container-class="MODAL_CONTAINER_WIDTH_CLASSES"
    content-class="tw:h-full tw:flex tw:items-center tw:justify-center tw:text-denim-900"
    :modal-style="{ height: '600px' }"
    :title="getLocaleText('external_item_select_action_modal.title')"
  >
    <div class="tw:text-center tw:py-4 tw:w-124">
      <p class="tw:mb-3 tw:text-lg tw:font-bold">
        {{ getLocaleText("external_item_select_action_modal.header") }}
      </p>

      <p class="tw:mb-6 tw:text-left">
        {{ getLocaleText("external_item_select_action_modal.explanation") }}
      </p>

      <div class="tw:flex tw:gap-4 tw:justify-center">
        <div
          v-for="button in BUTTONS"
          :key="button.name"
          class="tw:h-40 tw:w-1/2 tw:bg-white tw:hover:bg-denim-100 tw:transition-colors tw:rounded-xl tw:border tw:border-(--tw-color-denim-300) tw:flex tw:flex-col tw:items-center tw:justify-center tw:cursor-pointer"
          :data-testid="`${button.name}-button`"
          @click="button.click"
        >
          <div class="tw:mb-3">
            <BaseIcon
              :icon="button.icon"
              icon-class="tw:text-[2.5rem]"
            />
          </div>
          <span
            class="tw:text-base tw:font-bold tw:text-center tw:leading-tight"
          >
            {{ button.label }}
          </span>
        </div>
      </div>
    </div>
    <template #buttons>
      <BaseButton
        color="secondary"
        :label="getLocaleText('global.cancel')"
        new-design
        @click="handleCancel"
      />
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { type DesignSystemIcons } from "design-system/types";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseIcon } from "shared/components/base";
import BaseModal from "shared/components/core/modals/BaseModal.vue";

import { MODAL_CONTAINER_WIDTH_CLASSES } from "./shared/constants";

defineOptions({
  name: "ExternalItemSelectActionModal",
});

const emit = defineEmits<{
  bulkAdd: [];
  cancel: [];
  manualAdd: [];
}>();

const handleManualAdd = () => {
  emit("manualAdd");
};

const handleBulkAdd = () => {
  emit("bulkAdd");
};

const handleCancel = () => {
  emit("cancel");
};

const BUTTONS = [
  {
    name: "bulk-add",
    icon: "bulk-add" as DesignSystemIcons,
    label: getLocaleText("external_item_select_action_modal.bulk_add_button"),
    click: handleBulkAdd,
  },
  {
    name: "manual-add",
    icon: "manual-add" as DesignSystemIcons,
    label: getLocaleText("external_item_select_action_modal.manual_add_button"),
    click: handleManualAdd,
  },
];
</script>
